export const RETICULATION = {
  RETICULATION: {
    PAGE: "reticulation/page",
    LIST: "reticulation/list",
    CREATE: "reticulation/add",
    UPDATE: "reticulation/update",
    DELETE: "reticulation/delete",
    GET: "reticulation/get",
    GET_DATA: "reticulation/getData",
  },
};
